import React, { useEffect, useState } from 'react'
import { Redirect, Switch, useLocation } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import Header from '../components/Header'
import Footer from '../components/Footer'
import UserRoleModal from '../components/Modal/UserRoleModal/UserRoleModal'
import TrialExtensionModal from '../components/Modal/TrialExtensionModal/TrialExtensionModal'
import { API__PRODUCTS, API__USER } from '../api'
import { EDUCATION_GROUP_ID } from '../common/constants/ProductConstants'
import { isTrialSubscription } from 'common/utils/permissions.js'
import AccountSettings from '../pages/AccountSettings/AccountSettings'
import BillingAndPayments from '../pages/BillingAndPayments/BillingAndPayments'
import MyProjects from '../pages/MyProjects/MyProjects'
import ProjectAnalytics from '../pages/ProjectAnalytics/ProjectAnalytics'
import CustomRoute from '../routes/CustomRoute'
import AnalyticsMonitor from 'common/services/AnalyticsMonitor'
import useAnalyticsMonitor from 'components/useAnalyticsMonitor'
import OrganizationInitializer from '../components/OrganizationInitializer'
import { ORGANIZATIONS__REFRESH_SELECTED_SUBSCRIPTION, USER__SET_DETAILS } from '../store/actions'
import BlockEditor from '../pages/BlockEditor'

const MainLayout = ({ user, userDetails, organizations }) => {
    useAnalyticsMonitor()
    const location = useLocation()
    const dispatch = useDispatch()
    const [isOpenedRoleModal, setIsOpenedRoleModal] = useState(userDetails && !userDetails.roleInProjectDto)
    const [isOpenedTrialModal, setIsOpenedTrialModal] = useState(false)

    useEffect(() => {
        setIsOpenedRoleModal(userDetails && !userDetails.roleInProjectDto)
    }, [userDetails])

    const onSelectUserRole = async data => {
        const { selectedOrganizationId, selectedSubscription } = organizations
        const selectedGroup = data.group
        const selectedRole = data.role
        const updatedUser = await API__USER.UPDATE_DETAILS(user.id, {
            ...userDetails,
            login: userDetails.email,
            roleInProjectDto: {
                ...selectedRole,
                userGroupInProjectDto: selectedGroup,
            },
        })
        dispatch(USER__SET_DETAILS(updatedUser))

        const isTrial = isTrialSubscription()
        const isInactiveSubscription = selectedSubscription.started === null
        if (isInactiveSubscription && isTrial) {
            if (selectedGroup.customId === EDUCATION_GROUP_ID) {
                await API__PRODUCTS.ACTIVATE_EDUCATION_FREE(selectedOrganizationId)
            } else {
                await API__PRODUCTS.ACTIVATE_TRIAL(selectedOrganizationId)
            }
            AnalyticsMonitor.track('User role chosen', { role: selectedRole.id })
            await dispatch(ORGANIZATIONS__REFRESH_SELECTED_SUBSCRIPTION())
            setIsOpenedTrialModal(true)
        }
    }
    const isShowFooterAndHeader = !location.pathname.includes('/editor/')

    return (
        <OrganizationInitializer userId={user.id}>
            <div className="main">
                {isShowFooterAndHeader && <Header />}
                <main>
                    <Switch>
                        <CustomRoute path="/editor/:projectId?" component={BlockEditor} />
                        <CustomRoute exact path="/settings" component={AccountSettings} />
                        <CustomRoute exact path="/billing-and-payments" component={BillingAndPayments} />
                        <CustomRoute exact path="/my-projects" component={MyProjects} />
                        <CustomRoute path="/my-projects/:id/analytics" component={ProjectAnalytics} />

                        <Redirect from="*" to="/my-projects" />
                    </Switch>
                </main>
                {isShowFooterAndHeader && <Footer />}
                {isOpenedRoleModal && (
                    <UserRoleModal
                        isEditMode={false}
                        onSelect={data => onSelectUserRole(data)}
                        onClose={() => setIsOpenedRoleModal(false)}
                    />
                )}
                {isOpenedTrialModal && <TrialExtensionModal onClose={() => setIsOpenedTrialModal(false)} />}
            </div>
        </OrganizationInitializer>
    )
}

const mapStateToProps = state => ({
    user: state.user,
    userDetails: state.user_details,
    organizations: state.organizations,
})

export default connect(mapStateToProps, null)(MainLayout)
